import { render, staticRenderFns } from "./InvoiceAdd.vue?vue&type=template&id=36ac2382&scoped=true&"
import script from "./InvoiceAdd.vue?vue&type=script&lang=js&"
export * from "./InvoiceAdd.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAdd.vue?vue&type=style&index=0&id=36ac2382&prod&lang=scss&"
import style1 from "./InvoiceAdd.vue?vue&type=style&index=1&id=36ac2382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac2382",
  null
  
)

export default component.exports